module.exports = __webpack_public_path__ + "img/sas.9386d1ae.png";